module.exports = __webpack_public_path__ + "media/images/landing/illust/graph-categories-mobile-8313d4d37b6edd1895754618002627a1.png";